import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';

function AppIcon(_ref) {
  var Tag = _ref.tag,
      color = _ref.color,
      size = _ref.size,
      image = _ref.src,
      alt = _ref.alt,
      branded = _ref.branded,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["tag", "color", "size", "src", "alt", "branded", "className", "children"]);

  var classname = [className, 'app-icon', branded ? "app-icon-branded-" + color : "app-icon-" + color, size && "app-icon-" + size, image && 'border-0'].filter(function (a) {
    return a;
  }).join(' ');
  return React.createElement(Tag, Object.assign({}, props, {
    className: classname
  }), image ? React.createElement("img", {
    className: "w-100 h-100 align-baseline",
    src: image,
    alt: alt
  }) : children, branded && React.createElement("span", {
    className: "caret"
  }));
}

AppIcon.defaultProps = {
  tag: 'span',
  color: 'black'
};
export default AppIcon;